import "./AdHocServices.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Support from "./sections/Support";
import Services from "./sections/Services";
import AdhocSupport from "./sections/AdhocSupport";
import Approach from "./sections/Approach";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function AdHocServicesPage() {
  return <div>
      <Header />
      <Hero />
      <Support />
      <Services />
      <AdhocSupport />
      <Approach />
      <Action />
      <Footer />
    </div>;
}